import './Label.sass';

import React, { FC, useMemo } from 'react';
import { LabelProps } from './Label.interface';
import { classNames as cn } from '$utils';
import { IcStar28 } from '$assets';
import { useTranslator } from '$hooks';

export const Label: FC<LabelProps> = ({ type }) => {
  const t = useTranslator();
  const text = useMemo(() => {
    return [
      t('post_label_subscription_adult'),
      t('post_label_subscription_media'),
      t('post_label_subscription_author'),
    ][type - 1];
  }, [type]);

  return (
    <div className={cn('Label', ['adult', 'media', 'author'][type - 1])}>
      <div className="Label__icon">
        <IcStar28 />
      </div>
      <div className="Label__text">{text}</div>
    </div>
  );
};
